import { makeAutoObservable, toJS } from "mobx";
import { runInAction } from "mobx";
import { getStoredUser } from "../utils/auth.utils";

class RolesState {
  constructor() {
    makeAutoObservable(this);
  }
  // testConsole = () => {
  //   localStorage.removeItem("User");
  // };

  user = null;

  // user =
  //   localStorage.getItem("User") !== null ||
  //   localStorage.getItem("User") !== undefined
  //     ? JSON.parse(localStorage.getItem("User"))
  //     : localStorage.removeItem("User");

  checkRight = (right) => {
    const user = getStoredUser();
    return Boolean(user?.is_superuser || user?.permission.includes(right));
  };

  // Компании
  companys = this.checkRight("get_all_company"); // Все компании
  company_partners = this.checkRight("get_company_partners");
  company_id = this.checkRight("get_company_id"); //Компания по инн
  company_add = this.checkRight("post_company"); // Добавить компанию
  patch_company = this.checkRight("patch_company"); // Изменить компанию
  patch_company_assign_manager = this.checkRight("patch_company_assign_manager");
  get_client_lk_users = this.checkRight("get_client_lk_users");
  get_company_invoices = this.checkRight("get_company_invoices");
  post_company_partner_link = this.checkRight("post_company_partner_link");
  patch_company_partner_link = this.checkRight("patch_company_partner_link");
  // Площадки
  production_id = this.checkRight("get_production_id"); // Площадки компании
  patch_production = this.checkRight("patch_production");
  post_production = this.checkRight("post_production");
  // Лицензии
  license_id = this.checkRight("get_license_id"); // Лицензии компании
  post_generate = this.checkRight("post_generate");
  check_licensing = this.checkRight("get_pin_id");
  attach_licensing = this.checkRight("patch_attach_id");
  patch_unlink = this.checkRight("patch_unlink");
  licen_prol_id = this.checkRight("patch_licen_prol_id");
  patch_activity_license_id = this.checkRight("patch_activity_license_id");
  //get_all_licensing
  get_all_licensing = this.checkRight("get_all_licensing");

  // Подписки
  get_subscription_id = this.checkRight("get_subscription_id"); // Подписки компании
  patch_subscription = this.checkRight("patch_subscription"); // Изменить подписку компании

  // Софт
  soft_company_id = this.checkRight("get_soft_company_id"); // Софт компании

  // Сотрудники
  emploees = this.checkRight("get_all_user"); //Все сотрудники
  emploee_id = this.checkRight("get_user_id"); //Сотрудник по ид
  update_user = this.checkRight("update_user");
  reset_password = this.checkRight("reset_password");
  patch_relationship = this.checkRight("patch_relationship");
  all_roles = this.checkRight("get_all_roles");

  // Отчёты
  // reports = this.checkRight("get_all_soft_client"); // Все отчёты
  all_soft_client = this.checkRight("get_all_soft_client"); // Отчёты по софту
  subscription_rights = this.checkRight("valid_subscription"); // Отчёты по подпискам

  // Профиль
  get_my_profile = this.checkRight("get_my_profile");
  patch_my_profile = this.checkRight("patch_my_profile");
  patch_change_password = this.checkRight("patch_change_password");

  // Администрирование
  // admin_panel = localStorage.getItem("User")
  //   ? JSON.parse(localStorage.getItem("User")).permission.includes(
  //       "post_user"
  //     ) ||
  //     JSON.parse(localStorage.getItem("User")).permission.includes(
  //       "get_roles_id"
  //     ) ||
  //     JSON.parse(localStorage.getItem("User")).permission.includes(
  //       "patch_client_id"
  //     ) ||
  //     JSON.parse(localStorage.getItem("User")).is_superuser
  //   : null; // Админ панель
  admin_panel = null; // Админ панель

  readRight = async () => {
    // Компании
    const company_id = await this.checkRight("get_company_id");
    runInAction(() => {
      this.company_id = company_id;
    });
    const resCompany = await this.checkRight("get_all_company");
    runInAction(() => {
      this.companys = resCompany;
    });
    const company_add = await this.checkRight("post_company");
    runInAction(() => {
      this.company_add = company_add;
    });
    const patch_company = await this.checkRight("patch_company");
    runInAction(() => {
      this.patch_company = patch_company;
    });
    const company_partners = await this.checkRight("get_company_partners");
    runInAction(() => {
      this.company_partners = company_partners;
    });
    const patch_company_assign_manager = await this.checkRight(
      "patch_company_assign_manager",
    );
    runInAction(() => {
      this.patch_company_assign_manager = patch_company_assign_manager;
    });
    const get_client_lk_users = await this.checkRight("get_client_lk_users");
    runInAction(() => {
      this.get_client_lk_users = get_client_lk_users;
    });
    const get_company_invoices = await this.checkRight("get_company_invoices");
    runInAction(() => {
      this.get_company_invoices = get_company_invoices;
    });
    const post_company_partner_link = await this.checkRight(
      "post_company_partner_link",
    );
    runInAction(() => {
      this.post_company_partner_link = post_company_partner_link;
    });
    const patch_company_partner_link = await this.checkRight(
      "patch_company_partner_link",
    );
    runInAction(() => {
      this.patch_company_partner_link = patch_company_partner_link;
    });

    // Площадки
    const production_id = await this.checkRight("get_production_id");
    runInAction(() => {
      this.production_id = production_id;
    });

    const patch_production = await this.checkRight("patch_production");
    runInAction(() => {
      this.patch_production = patch_production;
    });

    const post_production = await this.checkRight("post_production");
    runInAction(() => {
      this.post_production = post_production;
    });

    // Лицензии

    const license_id = await this.checkRight("get_license_id");
    runInAction(() => {
      this.license_id = license_id;
    });
    const get_all_licensing = await this.checkRight("get_all_licensing");
    runInAction(() => {
      this.get_all_licensing = get_all_licensing;
    });

    const post_generate = await this.checkRight("post_generate");
    runInAction(() => {
      this.post_generate = post_generate;
    });

    const check_licensing = await this.checkRight("get_pin_id");
    runInAction(() => {
      this.check_licensing = check_licensing;
    });

    const attach_licensing = await this.checkRight("patch_attach_id");
    runInAction(() => {
      this.attach_licensing = attach_licensing;
    });

    const patch_unlink = await this.checkRight("patch_unlink");
    runInAction(() => {
      this.patch_unlink = patch_unlink;
    });

    const licen_prol_id = await this.checkRight("patch_licen_prol_id");
    runInAction(() => {
      this.licen_prol_id = licen_prol_id;
    });

    const patch_activity_license_id = await this.checkRight(
      "patch_activity_license_id"
    );
    runInAction(() => {
      this.patch_activity_license_id = patch_activity_license_id;
    });

    // Подписки

    const get_subscription_id = await this.checkRight("get_subscription_id");
    runInAction(() => {
      this.get_subscription_id = get_subscription_id;
    });

    const patch_subscription = await this.checkRight("patch_subscription");
    runInAction(() => {
      this.patch_subscription = patch_subscription;
    });

    // Софт

    const soft_company_id = await this.checkRight("get_soft_company_id");
    runInAction(() => {
      this.soft_company_id = soft_company_id;
    });

    // Сотрудники

    const emploees = await this.checkRight("get_all_user");
    runInAction(() => {
      this.emploees = emploees;
    });

    const emploee_id = await this.checkRight("get_user_id");
    runInAction(() => {
      this.emploee_id = emploee_id;
    });

    const update_user = await this.checkRight("update_user");
    runInAction(() => {
      this.update_user = update_user;
    });

    const reset_password = await this.checkRight("reset_password");
    runInAction(() => {
      this.reset_password = reset_password;
    });

    const patch_relationship = await this.checkRight(
      "resetpatch_relationship_password"
    );
    runInAction(() => {
      this.patch_relationship = patch_relationship;
    });

    const all_roles = await this.checkRight("get_all_roles");
    runInAction(() => {
      this.all_roles = all_roles;
    });

    // Отчёты

    const all_soft_client = await this.checkRight("get_all_soft_client");
    runInAction(() => {
      this.all_soft_client = all_soft_client;
    });
    const subscription_rights = await this.checkRight("valid_subscription");
    runInAction(() => {
      this.subscription_rights = subscription_rights;
    });

    // Профиль
    const get_my_profile = await this.checkRight("get_my_profile");
    runInAction(() => {
      this.get_my_profile = get_my_profile;
    });

    const patch_my_profile = await this.checkRight("patch_my_profile");
    runInAction(() => {
      this.patch_my_profile = patch_my_profile;
    });

    const patch_change_password = await this.checkRight(
      "patch_change_password"
    );
    runInAction(() => {
      this.patch_change_password = patch_change_password;
    });

    // Администрирование
    const user = getStoredUser();
    runInAction(() => {
      this.admin_panel = Boolean(
        user?.is_superuser ||
          user?.permission.includes("post_user") ||
          user?.permission.includes("get_roles_id") ||
          user?.permission.includes("patch_client_id"),
      );
    });
  };
}

export default new RolesState();
